import { Alpine as AlpineType } from 'alpinejs';

export default (Alpine: AlpineType) => {
  Alpine.data('stickyAddToCart', () => ({
    showStickyAddToCart: false,

    init() {
      document.addEventListener("scroll", () => {
        const gorgiasChat = document.getElementById('gorgias-chat-container');
        this.showStickyAddToCart = window.innerHeight < window.scrollY;

        if (gorgiasChat) {
          gorgiasChat.style.display = this.showStickyAddToCart ? 'none' : 'block';
        }
      });
    }
  }));
};